import { render, staticRenderFns } from "./FormTagsInput.vue?vue&type=template&id=6fe38f51"
import script from "./FormTagsInput.vue?vue&type=script&lang=js"
export * from "./FormTagsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports